var _defs, _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.26 7.142a7.004 7.004 0 016.55-5.103l-.167-.17A1.099 1.099 0 018.427 0H9a.5.5 0 110 1h-.573a.099.099 0 00-.07.168l.3.304c.17.174.257.398.262.624a7.007 7.007 0 015.822 5.046 2 2 0 01.022 3.707 7.003 7.003 0 01-13.526 0 2 2 0 01.022-3.707zM8 3.036a6 6 0 100 12 6 6 0 000-12zm-2.5 5a.5.5 0 110-1 .5.5 0 010 1zm2.5 6a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0-1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm2.5-5a.5.5 0 110-1 .5.5 0 010 1zm-2.5 4a.5.5 0 110-1 .5.5 0 010 1z",
    id: "kid_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "kid_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kid_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    fillRule: "nonzero",
    xlinkHref: "#kid_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#kid_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v15.964H0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10a1 1 0 110-2 1 1 0 010 2zM2 10a1 1 0 110-2 1 1 0 010 2z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#kid_svg__b)"
  }))));
}
export default SvgKid;